import { CancelOutlined } from '@mui/icons-material';
import { Breadcrumbs, Button, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { Export } from 'ui-component/icons';

export type DataFocusViewDialogTitleProps = {
    breadcrumbList: string[];
    onClose: () => void;
    onOpenDataFocusView: () => void;
};

export const DataFocusViewDialogTitle = ({ breadcrumbList, onClose, onOpenDataFocusView }: DataFocusViewDialogTitleProps) => {
    const lastEl = breadcrumbList[breadcrumbList.length - 1];
    const allButLast = breadcrumbList.slice(0, -1);

    return (
        <DialogTitle component={Grid} container sx={{ px: '24px', height: '64px', bgcolor: '#f5f6f7' }}>
            <Grid item xs>
                <Breadcrumbs separator=">">
                    {allButLast.map((el) => (
                        <Typography key={el} fontSize="20px" fontWeight={300}>
                            {allButLast}
                        </Typography>
                    ))}
                    <Typography color="secondary" fontSize="20px" fontWeight={500}>
                        {lastEl}
                    </Typography>
                </Breadcrumbs>
            </Grid>
            <Grid item xs="auto">
                <Button
                    variant="outlined"
                    onClick={onOpenDataFocusView}
                    color="secondary"
                    sx={{ borderRadius: '8px' }}
                    startIcon={<Export />}
                >
                    Open Data Focus View
                </Button>
            </Grid>
            <Grid item xs="auto">
                <IconButton color="secondary" onClick={() => onClose()}>
                    <CancelOutlined />
                </IconButton>
            </Grid>
        </DialogTitle>
    );
};
